import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Login from './pages/Login.jsx';
import Register from './pages/Register.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import Profile from './pages/Profile.jsx';
import SurveyData from './pages/SurveyData.jsx';
import Stock from './pages/Stock.jsx';
import Payment from './pages/Payment.jsx';
import { getStoredStaffSession, saveStaffSession, clearStaffSession } from './lib/auth.js';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    const session = getStoredStaffSession();
    setIsAuthenticated(Boolean(session?.token));
    setBootstrapped(true);
  }, []);

  const handleLogin = (session) => {
    saveStaffSession(session);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    clearStaffSession();
    setIsAuthenticated(false);
  };

  if (!bootstrapped) {
    return null;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/profile" replace /> : <Login onLogin={handleLogin} />}
        />
        <Route
          path="/register"
          element={isAuthenticated ? <Navigate to="/profile" replace /> : <Register />}
        />
        <Route
          path="/forgot-password"
          element={
            isAuthenticated ? <Navigate to="/profile" replace /> : <ForgotPassword />
          }
        />
        <Route
          path="/reset-password"
          element={
            isAuthenticated ? <Navigate to="/profile" replace /> : <ResetPassword />
          }
        />

        <Route
          path="/"
          element={
            isAuthenticated ? <Layout onLogout={handleLogout} /> : <Navigate to="/login" replace />
          }
        >
          <Route index element={<Navigate to="/profile" replace />} />
          <Route path="profile" element={<Profile />} />
          <Route path="survey-data" element={<SurveyData />} />
          <Route path="stock" element={<Stock />} />
          <Route path="payment" element={<Payment />} />
          <Route path="sales" element={<Navigate to="/payment" replace />} />
        </Route>

        <Route path="*" element={<Navigate to={isAuthenticated ? '/profile' : '/login'} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
